import ListingFiltersModel from '../../../filters/ListingFiltersModel'

export default class TagListingFiltersModel extends ListingFiltersModel {
  isTextRangeGroup (group, entity = '', displayType = '') {
    // Tags has no range groups
    return false
  }

  inactivateBaseFilter (entry, activeFilters, field = 'tagAllSlug') {
    return super.inactivateBaseFilter(entry, activeFilters, field)
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    let duplicateEntryIds = []
    const activeFilters = [...this.activeFilters]

    const entryId = entry.tagId
    const duplicateEntryNames = this.duplicateNamesPerGroup[group.tagGroupId]
    const duplicateEntryNamesForEntry = duplicateEntryNames?.find(e => {
      return e.ids.includes(entryId)
    })

    if (duplicateEntryNamesForEntry) {
      duplicateEntryIds = duplicateEntryNamesForEntry.ids
      return this.createLinkQueryStringForDuplicateEntry(group, entry, isFilterUsed, activeFilters, duplicateEntryIds)
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + group.tagGroupSlug + '/' + entry.tagSlug

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + group.tagGroupSlug + '/' + entry.tagSlug
      }
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
  }
}
